import React, { useEffect, useState } from "react";

export const LOADING_WARNING_DELAY_MS = 45_000;

function UnityLoadingWarning({ isLoading }) {
  const [dismissed, setDismissed] = useState(false);
  const [takingLonger, setTakingLonger] = useState(false);

  useEffect(() => {
    if (!isLoading) {
      setTakingLonger(false);
      return undefined;
    }

    const warningTimer = setTimeout(() => {
      setTakingLonger(true);
    }, LOADING_WARNING_DELAY_MS);

    return () => clearTimeout(warningTimer);
  }, [isLoading]);

  if (!isLoading || dismissed || !takingLonger) return null;

  return (
    <div
      className="warning-banner warning-banner--unity-loading"
      role="status"
      aria-live="polite"
    >
      <div className="warning-banner__icon" aria-hidden="true">⚠️</div>
      <div className="warning-banner__content">
        <strong>This is taking longer than usual</strong>
        Please check your internet connection.
      </div>
      <button
        type="button"
        className="warning-banner__dismiss"
        onClick={() => setDismissed(true)}
        aria-label="Dismiss loading notice"
      >
        ×
      </button>
    </div>
  );
}

export default UnityLoadingWarning;
